export default {
	title: '指标',
	url: 'indicators',
	subtitle:
		"列出您的成功指标并按类别组织——默认为平衡计分卡的4个视角：财务、客户、内部流程、学习与成长。可视化标签页以平衡计分卡的形式展示这些指标及其在各情景下的演变。",
	no_description: '未定义指标',
	context_worse: '负面',
	context_best: '正面',
	tabs: {
		filters: {
			title: '视图筛选'
		},
		general: {
			title: '常规'
		},
		export: {
			title: '导出'
		},
		comments: {
			title: '历史'
		},
		bot: {
			title: '智能'
		}
	},
	messages: {
		edit_constraint: '编辑指标',
		create_constraint: '新建指标'
	},
	onboarding: {
		title: '指标评审',
		description:
			"检查指标是否覆盖平衡计分卡的各个类别，并与行动计划相关联。"
	}
};
